module.exports = require("anteros-react-core");